import { Trello } from "../../external/trello-pu__core/trello-iframe/trello";
import IFrameInitializer, {
  TCapabilities,
} from "../../external/trello-pu__core/trello-iframe/iframe-initializer";
import { isLinkToTrelloCard } from "../utils/attachment-link-helper";

// declare global {
//   interface Window {
//     TrelloPowerUp: any;
//     // ga: any;
//     Trello: any;
//   }
// }

const API_KEY = process.env.API_KEY as string;
const APP_NAME = process.env.APP_NAME as string;

// const BOARDS_TARGETS_ICON =
//   "https://cdn.hyperdev.com/us-east-1%3A3d31b21c-01a0-4da2-8827-4bc6e88b7618%2Ficon-gray.svg";
const LINKS_ICON = location.origin + "/assets/link.svg";

function IFrameConnector() {
  // console.log("IFrameConnector");
  return (
    <IFrameInitializer
      capabilities={capabilities}
      API_KEY={API_KEY}
      APP_NAME={APP_NAME}
    />
  );
}

export default IFrameConnector;

const capabilities: TCapabilities = (getRestApi) => ({
  // "board-buttons": async function (t) {
  //   const isAuthorized: boolean = await getRestApi(t).isAuthorized();

  //   if (!isAuthorized) {
  //     return [
  //       {
  //         text: APP_NAME + " (Authorization needed)",
  //         icon: { dark: LINKS_ICON, light: LINKS_ICON },
  //         callback: (x) =>
  //           x.popup({
  //             title: "Authorize to continue",
  //             url: "./authorize",
  //           }),
  //       },
  //     ];
  //   }

  //   return [
  //     {
  //       text: APP_NAME,
  //       icon: { dark: LINKS_ICON, light: LINKS_ICON },
  //       callback: (x) =>
  //         x.modal({
  //           title: APP_NAME,
  //           url: "./modal",
  //           accentColor: "#ffffff",
  //           fullscreen: false,
  //         }),
  //     },
  //   ];
  // },
  "attachment-sections": function (t, options) {
    // options.entries is a list of the attachments for this card
    // you can look through them and 'claim' any that you want to
    // include in your section.

    // we will just claim urls for Yellowstone
    const claimed = options.entries.filter((e) => isLinkToTrelloCard(e.url));

    // you can have more than one attachment section on a card
    // you can group items together into one section, have a section
    // per attachment, or anything in between.

    if (claimed && claimed.length > 0) {
      return Promise.all([
        getRestApi(t).isAuthorized(),
        t.get("card", "shared", "isOpen"),
      ])
        .then(([isAuthorized, isOpen]: [boolean, boolean?]) => {
          if (isAuthorized && isOpen) {
            return [
              {
                id: "TrelloCards", // optional if you aren't using a function for the title
                claimed: claimed,
                icon: LINKS_ICON,
                title: APP_NAME,
                content: {
                  type: "iframe",
                  url: t.signUrl("./attachment-section", {
                    // arg: 'you can pass your section args here'
                  }),
                  height: 230,
                },
              },
            ];
          } else {
            return [];
          }
        })
        .catch(() => []);
    } else {
      return [];
    }
  },
  "card-buttons": function (t) {
    return getRestApi(t)
      .isAuthorized()
      .then(function (isAuthorized) {
        if (isAuthorized) {
          return [
            {
              icon: LINKS_ICON,
              text: APP_NAME,
              args: { myArgs: "You can access these with t.arg()" },
              callback: (x) =>
                x.popup({
                  title: APP_NAME,
                  url: "./card-button",
                  height: 68,
                  callback: t.closePopup,
                }),
            },
          ];
        } else {
          return [
            {
              icon: LINKS_ICON,
              text: APP_NAME + " (Authorization Needed)",
              args: { myArgs: "You can access these with t.arg()" },
              callback: (x) =>
                x.popup({
                  title: "Authorize to continue",
                  url: "./authorize",
                }),
            },
          ];
        }
      });
  },
  "card-badges": function (t: Trello.PowerUp.IFrame, opts) {
    const claimedAttachments = opts.attachments.filter((e) =>
      isLinkToTrelloCard(e.url)
    );

    if (claimedAttachments && claimedAttachments.length > 0) {
      type TInitialGet = [boolean, boolean?, TBoardsTargetsSO?];
      return Promise.all([
        getRestApi(t).isAuthorized(),
        t.get("card", "shared", "isOpen"),
        t.get("card", "shared", "boardTargets"),
      ])
        .then(
          ([isAuthorized, isAttachmentsSectionOn, targets]: TInitialGet) => {
            if (isAuthorized && isAttachmentsSectionOn) {
              const hasTargets = targets && targets.length > 0;
              // const text = hasTargets ? "Targets" : "";
              const color: Trello.Colors | undefined = hasTargets
                ? "blue"
                : "light-gray";

              return [
                {
                  // Dynamic badges can have their function rerun
                  // after a set number of seconds defined by refresh.
                  // Minimum of 10 seconds.
                  dynamic: function () {
                    // we could also return a Promise that resolves to
                    // this as well if we needed to do something async first
                    return {
                      text: "", //text
                      icon: LINKS_ICON,
                      color: color,
                      refresh: 10, // in seconds
                    };
                  },
                },
                // {
                //   // It's best to use static badges unless you need your
                //   // badges to refresh.
                //   // You can mix and match between static and dynamic
                //   text: "Static",
                //   icon: HYPERDEV_ICON, // for card front badges only
                //   color: null,
                // },
              ];
            } else return [];
          }
        )
        .catch(() => []);
    } else {
      return Promise.resolve([]);
    }
  },
});
